<template>
  <div>
    <div class="top-btn">
      <vxe-toolbar perfect v-if="this.$slots.btn">
        <template v-slot:buttons>
          <slot name="btn"></slot>
        </template>
      </vxe-toolbar>
    </div>
    <vxe-tooltip ref="xTip"></vxe-tooltip>
    <!-- <vxe-grid
      border
      highlight-current-row
      :show-all-overflow="true"
      row-id="id"
      ref="xGrid"
      auto-resize
      header-align="center"
      :resizable="resizable"
      :loading="loading"
      :data.sync="list"
      :columns="columns"
      :sortConfig="sortConfig"
      :edit-rules="editRules"
      :keyboard-config="{isArrow: true, isDel: true, isTab: true, isEdit: true}"
      :keep-source="keepSource"
      :edit-config="editConfig"
      :context-menu="{header: {options: headerMenus}, body:{options: bodyMenus},visibleMethod}"
      @context-menu-click="contextMenuClickEvent"
      @edit-closed="editClosed"
      @edit-actived="editActived"
      @cell-click="cellClickEvent"
      @cell-dblclick="cellDblClick"
      @cell-mouseenter="cellMouseenterEvent"
      @cell-mouseleave="cellMouseleaveEvent"
      :show-footer="showfooter"
      :footer-method="footerMethod"
      :span-method="mergeRowMethod"
    >
      <slot></slot>
      <template v-if="isOperate" v-slot:operate="{ row }">
          <div class="icon-btn">
            <vxe-button v-for="(item) in operateBtn" :key="item.btncode" class="icon-btn" :icon="item.btnicon" :title="item.btnname"  @click.native="vggridClick(item.btncode,row)" circle></vxe-button>
          </div>
      </template>
    </vxe-grid>-->
    <vxe-grid
      ref="xGrid"
      border
      highlight-current-row
      :show-all-overflow="true"
      row-id="id"
      auto-resize
      stripe
      :resizable="resizable"
      header-align="center"
      :loading="loading"
      :export-config="{}"
      :footer-method="footerMethod"
      :columns="columns"
      :data.sync="list"
      :sortConfig="sortConfig"
      :edit-rules="editRules"
      :keyboard-config="{
        isArrow: true,
        isDel: true,
        isTab: true,
        isEdit: true,
      }"
      :keep-source="keepSource"
      :edit-config="editConfig"
      :context-menu="{
        header: { options: headerMenus },
        body: { options: bodyMenus },
        visibleMethod,
      }"
      @context-menu-click="contextMenuClickEvent"
      @edit-closed="editClosed"
      @edit-actived="editActived"
      @cell-click="cellClickEvent"
      @cell-dblclick="cellDblClick"
      @cell-mouseenter="cellMouseenterEvent"
      @cell-mouseleave="cellMouseleaveEvent"
      :show-footer="showfooter"
      :footer-span-method="footerColspanMethod"
      :span-method="mergeRowMethod"
    >
      <slot></slot>
      <template v-if="isOperate" v-slot:operate="{ row }">
        <div class="icon-btn">
          <vxe-button
            v-for="item in operateBtn"
            :key="item.btncode"
            class="icon-btn"
            :icon="item.btnicon"
            :title="item.btnname"
            @click.native="vggridClick(item.btncode, row)"
            circle
          ></vxe-button>
        </div>
      </template>
    </vxe-grid>
    <div v-if="showPage">
      <vxe-pager
        :loading="loading"
        :page-sizes="[5, 10, 20, 50, 100]"
        :current-page="tablePage.currentPage"
        :page-size="tablePage.pageSize"
        :total="tablePage.total"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange"
      ></vxe-pager>
    </div>
    <!--<el-dialog :visible.sync="browsForm" width="80%" :close-on-click-modal="false" :show-close="true"-->
    <!--:destroy-on-close="true" :before-close="browsClose" @open="browsInit()">-->
    <!--<brows ref="brows" :browscode="browscode" :multiLine="addNewMultiLine" @closeDialog="closeDialog" @sureDialog="sureDialog"></brows>-->
    <!--</el-dialog>-->
  </div>
  <!--:pager-config="tablePage"-->
  <!--@page-change="handlePageChange"-->
</template>
<script>
/* eslint-disable */
import XEUtils from "xe-utils";
import request from "@/utils/request";
import * as calUtils from "../../assets/js/calUtils";
import lebcquery from "../common/lebcquery";
import brows from "../common/brows";
export default {
  components: { brows },
  name: "vggrid",
  props: {
    editRules: {},
    random: 0,
    tableheight: 0,
    flexname: "",
    resizable: {},
    list: {},
    cols: {},
    total: 0,
    edit_config: "",
    sortConfig: {},
    showfooter: {},
    showPage: {},
    needRowNum: false,
    needSelection: false,
    needBlackRow: true,
    needPopMenu: true,
    canbeEdit: false,
    // footerSum: {
    //   type: Array,
    //   default: () => {
    //     return [];
    //   },
    // },
    mergeRow: {
      type: Array,
      default: () => {
        return [];
      },
    },
    operateBtn: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isOperate: {
      type: Boolean,
      default: false,
    },
    defaultPage: {
      type: Number,
      default: 20,
    },
    loading: {
      type: Boolean,
      default: false
    }
    // footmethod: {
    //   type: Function,
    //   default: (event) => {
    //       this.default.methods.footmethod();
    //   }
    // }
  },
  data() {
    return {
      errNum: 0,
      tableData: [],
      columns: [],
      keepSource: false,
      editConfig: {},
      currow: {},
      curcol: {},
      customCols: [],
      sumcols: [],
      headerMenus: [
        [
          {
            code: "showAllColumn",
            name: "取消所有隐藏列",
          },
          {
            code: "hideColumn",
            name: "隐藏列",
          },
        ],
      ],
      bodyMenus: [],
      tablePage: {
        total: this.total,
        currentPage: 1,
        pageSize: this.defaultPage ? this.defaultPage : 20,
      },
      browsForm: false,
      browscode: "",
      triggercols: [],
      toolbar: {
        id: "vggridtoolbar",
        refresh: true,
        resizable: {
          storage: true,
        },
        setting: { storage: true },
      },
      addNewMultiLine: false,
    };
  },
  async created() {
    this.init();
  },
  async activated() {
    // this.init()
  },
  mounted() {},
  watch: {
    loading (val) {
      console.log(val, '----')
    },
    $route(to, from) {
      if (to.name === "reportQuery") {
        if (to.query.reportid !== from.query.reportid) {
          this.init();
        }
      }
    },
    total(val1, val2) {
      this.tablePage.total = val1;
    },
    pageSize(val1, val2) {
      this.tablePage.pageSize = val1;
    },
    list() {
      this.setSelectRows();
    },
    operateBtn: {
      deep: true,
      handler: function (newVal, oldVal) {
        return newVal;
      },
    },
    isOperate(newVal, oldVal) {
      this.isOperate = newVal;
      if (this.cols[this.cols.length - 1].title !== "操作" && this.isOperate) {
        this.cols.push({ title: "操作", slots: { default: "operate" } });
      } else this.cols.pop();
      return newVal;
    },
    random(newVal, oldVal) {
      this.init();
    },
  },
  methods: {
    footerMethod({ columns, data }) {
      // return this.footerSum
    },
    async init() {
      setTimeout(() => {
        if (this.flexname) {
          this.getFlexcols();
        } else {
          this.columns = this.cols;
          if (
            this.cols[this.cols.length - 1].title !== "操作" &&
            this.isOperate
          ) {
            this.cols.push({ title: "操作", slots: { default: "operate" } });
          }
          this.loadComboData();
          this.setSelectRows();
          this.getTriggercols();
          this.setCustomColumns();
        }
        this.headerMenus = [];
        if (this.needBlackRow && this.canbeEdit) {
          this.$refs.xGrid
            .insertAt({ isadd: true }, -1)
            .then(({ row }) =>
              this.$refs.xGrid.setActiveCell(row, this.activeCell)
            );
        }
        if (this.canbeEdit) {
          this.editConfig = {
            trigger: "click",
            mode: "cell",
            showStatus: true,
            autoClear: false,
          };
          this.keepSource = true;
        } else {
          this.editConfig = {};
          this.keepSource = false;
        }
        if (!this.needPopMenu || !this.canbeEdit) {
          this.bodyMenus = [];
        } else {
          this.getPopMenus();
        }
      }, 50);
    },
    async getPopMenus() {
      let popMenus = [
        {
          code: "addBlackRows",
          name: "添加行",
        },
        {
          code: "addFiveBlackRows",
          name: "添加5行",
        },
        {
          code: "removeBlackRows",
          name: "删除行",
        },
        {
          code: "insertBlackRows",
          name: "插入行",
        },
        {
          code: "insertFiveBlackRows",
          name: "插入5行",
        },
      ];
      if (this.flexname) {
        let docgenList = await request({
          url: "/kfgl/docgen/getDocgenListByFlexcode",
          method: "get",
          params: { flexcode: this.flexname },
        });
        docgenList.forEach((item) => {
          popMenus.push({
            code: "docgen_" + item.docgencode,
            name: item.docgenname,
          });
        });
      }
      this.bodyMenus = [popMenus];
    },
    async getFlexcols() {
      this.columns = [];
      let flexcols = await request({
        url: "/kfgl/flex/getFlexcolListByFlexcode",
        method: "get",
        params: {
          flexcode: this.flexname,
          comid: this.$store.getters.loginUser.usercomid,
        },
      });
      let column = {};
      if (this.needSelection) {
        column = {
          type: "checkbox",
          fieldtype: "I",
          title: "选择",
          calculExpr: "",
          width: 80,
        };
        this.columns.push(column);
      }
      if (this.needRowNum) {
        column = {
          type: "seq",
          fieldtype: "I",
          title: "行号",
          calculExpr: "",
          width: 80,
        };
        this.columns.push(column);
      }
      await (async () => {
        for (let i = 0; i < flexcols.length; i++) {
          column = {};
          let item = flexcols[i];
          column.field = item.flexcolcode;
          column.title = item.flexcolname;
          column.fieldtype = item.flexcoltype;
          column.hide = item.flexcolhide;
          column.brows = item.flexcolbrows;
          column.genflexid = item.flexcolgenflexid;
          column.getvaluestr = item.flexcolgetvaluestr;
          column.setvaluestr = item.flexcolsetvaluestr;
          column.calculExpr = item.flexcolcalculexpr;
          column.issum = item.flexcolissum;
          column.triggercol = item.flexcolgriggercol;
          column.flexcoleditflg = item.flexcoleditflg;
          if (item.flexcoltype === "D") {
            column.formatter = ["toDateString", "yyyy-MM-dd"];
          }
          if (item.flexcoltype === "T") {
            column.formatter = ["toDateString", ""];
          }
          if (item.flexcoleditflg === "2") {
            if (this.canbeEdit) {
              column.editRender = { name: "input" };
            }
          }
          if (item.flexcoleditflg === "3") {
            let res = [];
            if (item.flexcolsyscode) {
              res = await request({
                url: "/kfgl/syscode/getSysCodeList",
                method: "get",
                params: { syscode: item.flexcolsyscode },
              });
              res.splice(0, 0, {
                label: "请选择",
                value: 0,
              });
            }
            if (item.flexcolbrows) {
              res = await request({
                method: "get",
                url: "/kfgl/brows/getBrowsDataList",
                params: {
                  comid: this.$store.getters.loginUser.usercomid,
                  browscode: item.flexcolbrows,
                },
              });
              res.splice(0, 0, {
                label: "请选择",
                value: 0,
              });
            }
            column.editRender = {
              name: "ElSelect",
              props: { disabled: !this.canbeEdit },
              options: res,
            };
          }
          if (item.flexcoleditflg === "4") {
            if (this.canbeEdit) {
              column.editRender = {
                name: "ElInput",
                props: { readonly: true, suffixIcon: "el-icon-search" },
              };
            }
          }
          if (item.flexcoleditflg === "5") {
            if (this.canbeEdit) {
              column.editRender = { name: "ElSwitch" };
            }
          }
          if (item.flexcolhide === "1") {
            this.customCols.push({
              field: item.flexcolcode,
              visible: false,
            });
          }
          if (item.flexcolissum === "1") {
            this.sumcols.push(item.flexcolcode);
          }
          this.columns.push(column);
        }
      })();
      await this.setSelectRows();
      await this.getTriggercols();
      await this.loadComboData();
      await this.reloadCustomColunms();
    },
    async reloadCustomColunms() {
      let that = this;
      setTimeout(() => {
        that.$refs.xGrid.reloadCustoms(this.customCols);
      }, 50);
    },
    async setCustomColumns() {
      this.customCols = [];
      this.columns.forEach((item) => {
        if (item.hide === "1") {
          this.customCols.push({
            field: item.field,
            visible: false,
          });
        }
        if (item.issum === 1) {
          this.sumcols.push(item.field);
        }
      });
      this.reloadCustomColunms();
    },
    async setSelectRows() {
      let that = this;
      let checkRowKeys = [];
      setTimeout(() => {
        that.list.forEach((item) => {
          if (item.selected) {
            checkRowKeys.push(item);
          }
        });
        that.$refs.xGrid.setSelection(checkRowKeys, true);
      }, 300);
    },
    async loadComboData() {
      // let options = [{value: 1,label: 'pcs'},{value: 2,label: '箱'},{value: 3,label: '件'}]
      //this.columns[this.findTableColumnIndexByField('fieldtype')].editRender.options = this.options
      this.columns.forEach(async (item) => {
        if (item.syscode) {
          let options = await request({
            url: "/kfgl/syscode/getSysCodeList",
            method: "get",
            params: item,
          });
          options.splice(0, 0, {
            label: "请选择",
            value: 0,
          });
          this.columns[
            this.findTableColumnIndexByField(item.field)
          ].editRender.options = options;
        }
      });
    },
    cellClickEvent(
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      cell
    ) {
      // 这里可以增加帮助器的弹出层选择数据比较多的录入项
      this.currow = row;
      this.curcol = row.column;
      this.$emit("cellClick", row, this.$refs.xGrid);
    },
    cellDblClick(
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      cell
    ) {
      this.$emit("cellDblClick", row, this.$refs.xGrid);
    },
    findTableColumnIndexByField(field) {
      let columnIndex = this.columns.findIndex((item) => item.field === field);
      return columnIndex;
    },
    closeDialog() {
      this.browsForm = false;
    },
    sureDialog(selectRecords, insertflg) {
      if (selectRecords.length === 0) {
        this.$message.warning("至少需要选择一行！");
        return;
      }
      let records = [];
      let setvaluestr = this.curcol.own.setvaluestr;
      let getvaluestr = this.curcol.own.getvaluestr;
      if (selectRecords) {
        selectRecords.forEach((res) => {
          let record = {};
          if (setvaluestr && getvaluestr) {
            let setarr = setvaluestr.split(",");
            let getarr = getvaluestr.split(",");
            for (let i = 0; i < setarr.length; i++) {
              record[setarr[i]] = res[getarr[i]] + "";
            }
            records.push(record);
          }
        });
      }
      if (records) {
        if (insertflg) {
          this.$refs.xGrid
            .insertAt(records, this.currow.row)
            .then(({ row }) =>
              this.$refs.xGrid.setActiveCell(row, this.activeCell)
            );
        } else {
          this.$refs.xGrid.reloadRow(this.currow.row, records[0]);
        }
      }
      this.closeDialog();
    },
    editActived({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex,
      cell,
    }) {
      this.currow = row;
      this.curcol = column;
      this.browscode = column.own.brows;
      if (column.own.flexcoleditflg == 4) {
        this.addNewMultiLine = row.isadd ? true : false;
        this.browsForm = true;
      }
    },
    browsInit() {
      console.log(this.$refs.xGrid.$refs.xTable);
    },
    browsClose(done) {
      done();
    },
    editClosed(row) {
      let that = this;
      /*        if (that.columns[row.columnIndex].addNewRowFlg) {
          if (that.list.length === row.rowIndex+1 && that.list[row.rowIndex][that.columns[row.columnIndex].field]) {
            that.list.push({
            })

          }
        }*/
      if (that.columns[row.columnIndex].triggercol === 1) {
        that.columns.forEach(function (item, index, arr) {
          if (arr[index].calculExpr !== "") {
            that.calculColValue(
              arr[index].field,
              arr[index].calculExpr,
              that.triggercols,
              row
            );
          }
        });
      }
    },
    //获取触发列数组
    getTriggercols() {
      this.columns.forEach((item) => {
        if (item.triggercol === 1) {
          this.triggercols.push(item.field);
        }
      });
    },
    calculColValue(calField, expr, triggerCols, row) {
      let that = this;
      let rowIndex = row.rowIndex;
      triggerCols.forEach(function (item, index) {
        let colValue = row.row[item];
        expr = expr.replace(item, colValue);
      });
      let result = calUtils.calStr(expr);
      if (result) {
        that.setValueToCell(row, calField, result);
      }
    },
    setValueToCell(row, calField, val) {
      row.row[calField] = Number(Number(val).toFixed(2));
      this.$refs.xGrid.updateFooter();
    },
    getObjectValueByKeyStr(obj, field) {
      let value;
      Object.keys(obj).forEach(function (key, index) {
        if (key === field) {
          let values = Object.values(obj);
          value = values[index];
        }
      });
      return value;
    },
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.$emit("pagechange", this.tablePage);
    },
    visibleMethod({ type, options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach((list) => {
        list.forEach((item) => {
          if (["copy"].includes(item.code)) {
            item.disabled = isDisabled;
          }
          if (["clear"].includes(item.code)) {
            item.visible = isVisible;
          }
        });
      });
      return true;
    },
    contextMenuClickEvent({ menu, row, column }) {
      let xGrid = this.$refs.xGrid;
      if (menu.code.substr(0, 7) === "docgen_") {
        this.$emit("gendoc", menu.code.substr(7));
      } else {
        switch (menu.code) {
          case "removeBlackRows":
            this.$refs.xGrid.remove(row);
            break;
          case "insertBlackRows":
            this.$refs.xGrid
              .insertAt({}, row)
              .then(({ row }) =>
                this.$refs.xGrid.setActiveCell(row, this.activeCell)
              );
            break;
          case "insertFiveBlackRows":
            for (let i = 0; i < 5; i++) {
              this.$refs.xGrid
                .insertAt({}, row)
                .then(({ row }) =>
                  this.$refs.xGrid.setActiveCell(row, this.activeCell)
                );
            }
            break;
          case "addBlackRows":
            this.$refs.xGrid
              .insertAt({}, -1)
              .then(({ row }) =>
                this.$refs.xGrid.setActiveCell(row, this.activeCell)
              );
            break;
          case "addFiveBlackRows":
            for (let i = 0; i < 5; i++) {
              this.$refs.xGrid
                .insertAt({}, -1)
                .then(({ row }) =>
                  this.$refs.xGrid.setActiveCell(row, this.activeCell)
                );
            }
            break;
          case "hideColumn":
            //            this.$refs.xGrid.hideColumn(column)
            column.visible = false;
            this.$refs.xGrid.refreshColumn();
            break;
          case "showAllColumn":
            let that = this;
            let columns = that.$refs.xGrid.getTableColumn();
            that.$refs.xGrid.getTableColumn().forEach(function (item) {
              item.visible = true;
            });
            that.$refs.xGrid.refreshColumn();
            break;
        }
      }
    },
    cellMouseenterEvent({ row, column, cell }) {
      if (this.needPopMenu && this.canbeEdit) {
        this.$refs.xTip.toVisible(cell, `鼠标右键新增行！`);
      }
    },
    cellMouseleaveEvent({ row, column, cell }) {
      this.$refs.xTip.close();
    },
    // TODO 待优化
    async validError() {
      const errMap = await this.$refs.xGrid
        .fullValidate()
        .catch((errMap) => errMap);
      if (errMap) {
        let msgList = [];
        Object.values(errMap).forEach((errList) => {
          errList.forEach((params) => {
            let { rowIndex, column, rules } = params;
            rules.forEach((rule) => {
              msgList.push(
                `第 ${rowIndex + 1} 行 ${column.title} ${rule.message}`
              );
            });
          });
        });
        this.$XModal.message({
          status: "error",
          message: () => {
            return [
              <div class="red" style="max-height: 400px;overflow: auto;">
                {msgList.map((msg) => (
                  <div>{msg}</div>
                ))}
              </div>,
            ];
          },
        });
      } else {
        return true;
      }
    },
    vggridClick(code, row) {
      this.$emit("vggridClick", code, row);
    },
    mergeRowMethod({ row, $rowIndex, column, data }) {
      let fields = this.mergeRow;
      // console.log('=====this.mergeRow==========',this.mergeRow);

      let cellValue = XEUtils.get(row, column.property);
      if (cellValue && fields.includes(column.property)) {
        let prevRow = data[$rowIndex - 1];
        let nextRow = data[$rowIndex + 1];
        if (prevRow && XEUtils.get(prevRow, column.property) === cellValue) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let countRowspan = 1;
          while (
            nextRow &&
            XEUtils.get(nextRow, column.property) === cellValue
          ) {
            nextRow = data[++countRowspan + $rowIndex];
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 };
          }
        }
      }
    },
    footerColspanMethod({ _rowIndex, _columnIndex }) {
      // let modle = this.footmethod(_rowIndex, _columnIndex )
      // return modle
    },
    // btnClick(code,row){
    //   switch (code){
    //     case 'CHG':
    //       this.$emit('CHG',row)
    //       break;
    //     case 'DEL':
    //       this.$emit('DEL',row)
    //       break;
    //     case ''
    //   }
    // },
  },
};
</script>
<style lang="scss" scoped>
.top-btn {
  overflow: auto;
  .vxe-toolbar {
    height: 100%;
    padding: 5px 5px;
  }
}
.icon-btn {
  .vxe-button {
    font-size: 17px !important;
    // border: 0;
  }
}
// .vxe-button.type--button:not(.is--disabled):focus {
//     border-color: #409eff;
//     // -webkit-box-shadow: 0 0 0.25em 0 #409eff;
//     /* box-shadow: 0 0 0.25em 0 #409eff; */
//     box-shadow: 0 0 black !important;
// }
</style>
